import { Tooltip } from "antd";
import { FC, useState } from "react";

const EllipsisText: FC<{ title: string; className?: string }> = ({
  title,
  className,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const handleMouseEnter = (e: React.MouseEvent<HTMLParagraphElement>) => {
    const target = e.currentTarget;
    setShowTooltip(target.scrollWidth > target.clientWidth);
  };

  return (
    <Tooltip title={showTooltip ? title : ""}>
      <p className={className} onMouseEnter={handleMouseEnter}>
        {title}
      </p>
    </Tooltip>
  );
};
export default EllipsisText;
